class HeaderDelegate {
    setDrawerOpen(isOpen) {
        this.setState({ drawerOpen: isOpen });
    }

    setUnreadCount(unreadCount) {
        this.setState({ unreadCount: Math.max(0, Number(unreadCount) || 0) });
    }

    setBreadcrumbSnapshot(breadcrumbSnapshot) {
        this.setState({ breadcrumbSnapshot });
    }

    setNotificationsOpen(notificationsOpen) {
        this.setState({ notificationsOpen: !!notificationsOpen });
    }

    setMenuItems(menuItems) {
        this.setState({ menuItems: menuItems || [] });
    }

    setMenuLoading(menuLoading) {
        this.setState({ menuLoading });
    }

    setMenuError(menuError) {
        this.setState({ menuError });
    }

    /** Optimistically flag one menu row as read. */
    markMenuItemRead(id) {
        const readAt = new Date().toISOString();
        this.setState((prev) => ({
            menuItems: (prev.menuItems || []).map((item) => (item.id === id && !item.readAt ? { ...item, readAt } : item)),
        }));
    }
}

export default HeaderDelegate;
